import { Box, List, Typography } from '@mui/material';
import { ReactNode } from 'react';

export type CardListItemType = {
  label: string;
  id: any;
  count: number;
  excludeTargets?: string[];
};

type CardListProps = {
  value: CardListItemType[];
  label: string;
  'data-testid'?: string;
  renderItem?: (item: any) => ReactNode;
};

const CardList = ({
  value,
  label,
  'data-testid': dataTestId = 'CardList',
  renderItem,
}: CardListProps) => {
  return (
    <Box data-testid={`${label}${dataTestId}`}>
      {value.length > 0 && (
        <>
          <Typography variant="h6">{label}</Typography>
          <List sx={{ p: 0 }}>{value.map(item => renderItem(item))}</List>
        </>
      )}
    </Box>
  );
};

export default CardList;
